module.exports = "images/teamed_image_03.png";